import { ErrorHelper } from '@/helpers/ErrorHelper'
import { WebApi } from '@/services/WebApi'

export const KioskContractTemplateCacheMixin = {
  data () {
    return {
      kioskContractTemplate: null,
      loadingKioskContractTemplate: false,
      kioskContractTemplateError: ''
    }
  },
  methods: {
    fetchKioskContractTemplate () {
      const self = this
      self.loadingKioskContractTemplate = true
      self.kioskContractTemplateError = ''
      return WebApi.get('Kiosk/ContractTemplate')
        .then(response => { self.kioskContractTemplate = response.data })
        .catch(error => { self.kioskContractTemplateError = ErrorHelper.getError(error) })
        .finally(() => { self.loadingKioskContractTemplate = false })
    }
  }
}
